/** Collision-resistant enough id for messages, tool calls, log entries. */
export function makeId(prefix = "id"): string {
  return `${prefix}_${Date.now().toString(36)}${Math.random()
    .toString(36)
    .slice(2, 8)}`;
}
